import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { useStudy } from '../hooks';
const StudyContext = createContext({});
export const StudyProvider = ({ children }) => {
    const creativeStudy = useStudy();
    return (_jsx(StudyContext.Provider, { value: creativeStudy, children: children }));
};
export const useStudyContext = () => {
    const context = useContext(StudyContext);
    if (!context) {
        throw new Error('useStudyContext must be used within a StudyProvider');
    }
    return context;
};
